module.exports = __webpack_public_path__ + "img/eec3712.jpg";